import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';
import Picture from 'components/picture';
import { useFeatureLoyaltyUi } from 'hooks/use-feature-loyalty-ui';

import { ContentHeader, ContentText, ContentWrapper } from './styled';
interface IDialogActionSheetProps {
  isOpen?: boolean;
  handleOnClose?: () => void;
  accountEmail?: string;
  handleLinkAccount: () => Promise<void>;
  handleSwitchAccount: () => Promise<void>;
}

export const WalmartWelcomeBack = ({
  isOpen = false,
  handleOnClose,
  accountEmail,
  handleLinkAccount,
  handleSwitchAccount,
}: IDialogActionSheetProps) => {
  const { featureLoyaltyUi } = useFeatureLoyaltyUi();
  const { formatMessage } = useIntl();
  const logo = featureLoyaltyUi?.rewardsLogo?.locale;

  const onConfirm = () => {
    handleLinkAccount();
  };
  const onDismiss = () => {
    handleSwitchAccount();
  };

  return (
    <ActionsheetWrapper
      isOpen={isOpen}
      onOpenEventMessage="Walmart Welcome Back modal"
      onClose={handleOnClose}
    >
      <ActionsheetContent>
        <ContentWrapper>
          <Picture
            image={logo}
            alt={formatMessage({ id: 'royalPerks' })}
            objectFitContain
            lazy={false}
            lqOff
            width="$48"
            height="$24"
          />
          <ContentHeader>{formatMessage({ id: 'welcomeBack' })}</ContentHeader>
          <ContentText>
            {formatMessage({ id: 'weWillLinkWalmart' })}
            {accountEmail}
          </ContentText>
          <ActionButton fullWidth onPress={onConfirm} mb="$4">
            {formatMessage({ id: 'linkWithThisAccount' })}
          </ActionButton>
          <ActionButton
            fullWidth
            onPress={onDismiss}
            mb="$4"
            variant={ActionButtonVariants.TEXT_ONLY}
          >
            {formatMessage({ id: 'linkWithDifferentAccount' })}
          </ActionButton>
        </ContentWrapper>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
